var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceSmile = function SvgFaceSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.48 16.307a5.013 5.013 0 0 1-6.293 0A1.335 1.335 0 1 0 8.48 18.36a7.573 7.573 0 0 0 9.707 0 1.335 1.335 0 1 0-1.707-2.053ZM9.333 12a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667Zm8-2.667a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666Zm-4-9.333a13.333 13.333 0 1 0 0 26.667 13.333 13.333 0 0 0 0-26.667Zm0 24a10.666 10.666 0 1 1 0-21.333 10.666 10.666 0 0 1 0 21.333Z",
    fill: "#fff"
  })));
};
export default SvgFaceSmile;